import { useState } from "react";
import { Alert, Avatar, Box, Button, Card, CardContent, Stack, Typography } from "@mui/material";
import { api } from "../lib/api-client";
import { useAuthStore } from "../stores/auth-store";
import { GlobalInput } from "../components/GlobalInput";
import { useTranslate } from "../i18n";

export function ProfilePage() {
  const { user, setUser } = useAuthStore();
  const [displayName, setDisplayName] = useState(user?.displayName ?? "");
  const [saved, setSaved] = useState(false);
  const __ = useTranslate();
  if (!user) return null;
  return <Box maxWidth={720}>
    <Typography variant="h4" fontWeight={800} mb={3}>{__("Profile")}</Typography>
    {saved && <Alert severity="success" sx={{ mb: 2 }}>{__("บันทึกแล้ว")}</Alert>}
    <Card variant="outlined"><CardContent sx={{ p: 3 }}>
      <Stack direction={{ xs: "column", sm: "row" }} spacing={3} alignItems={{ xs: "center", sm: "flex-start" }}>
        <Avatar src={user.photoUrl ?? undefined} sx={{ width: 88, height: 88, flexShrink: 0 }}>{user.displayName.charAt(0)}</Avatar>
        <Box flex={1} width="100%">
          <GlobalInput fullWidth label={__("ชื่อที่แสดง")} value={displayName} onChange={(event) => setDisplayName(event.target.value)} sx={{ mb: 2 }} />
          <GlobalInput fullWidth label={__("Email")} value={user.email} disabled />
        </Box>
      </Stack>
      <Box textAlign="right" mt={3}><Button variant="contained" disabled={!displayName.trim()} onClick={() => void api.updateProfile(displayName).then((updated) => { setUser(updated); setSaved(true); setTimeout(() => setSaved(false), 2000); })}>{__("บันทึก")}</Button></Box>
    </CardContent></Card>
  </Box>;
}
